import { Link } from "react-router-dom";
import Header from "@/components/Header";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen">
      <Header />
      <main className="pt-40 pb-24 px-4 max-w-lg mx-auto text-center">
        <div className="glass-strong p-10" data-testid="payment-cancel-card">
          <XCircle className="w-16 h-16 mx-auto text-amber-500" />
          <h1 className="mt-4 font-display text-4xl">Checkout cancelled</h1>
          <p className="mt-2 text-[var(--fg-muted)]">
            No charge was made — your reserved block will expire in 30 minutes.
          </p>
          <div className="mt-6 flex items-center justify-center gap-2">
            <Link to="/" className="btn-primary">Back to grid</Link>
          </div>
        </div>
      </main>
    </div>
  );
}
